import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HomeSlider } from '../../../shared/data/slider';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    standalone: false
})
export class SliderComponent implements OnInit {

  @Input() sliders: any[];
  @Input() class: string;
  @Input() textClass: string;
  @Input() category: string;
  @Input() buttonText: string;
  @Input() buttonClass: string;
  env = environment;
  
  constructor(private sanitizer: DomSanitizer) {}
  ngOnInit(): void {
  }

  public HomeSliderConfig: any = HomeSlider;

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
